export const isSecondaryCustomer = (jointOwners) => jointOwners?.some(jointOwner => jointOwner.relationshipType === 'CREATED_FROM') || false;
export const isJointOwnerPendingKyc = (jointOwners) => {
    const pendingStatuses = ['KYC_PENDING', 'PENDING_OOW_QUESTIONS'];
    if (!jointOwners?.length) {
        return false;
    }
    return pendingStatuses.includes(jointOwners[0].kycRequestStatus);
};
